// Partial — showcase da Central de Conquistas (revisão da equipe, 11/07).
// Rota sem link de navegação; página estática sem rede e sem mutação.
import { createElement } from "react";
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { Navigate, useLocation } from "react-router-dom";
import { RequireAuth } from "@/features/auth";
import ConquestsMasterRouteGate from "./ConquestsMasterRouteGate";
import { areaFromDestination } from "./v3/conquests-area";
import { CONQUESTS_ROUTE_PATH } from "./v3/conquests-route";
import { withConquestsAreaSearchParams } from "./v3/conquests-url";

const GamificationShowcasePage = lazyWithRetry(
  () => import("./showcase/GamificationShowcasePage"),
);
const ConquestsRoutePage = lazyWithRetry(
  () => import("./v3/pages/ConquestsRoutePage"),
);

function LegacyConquestsRedirect() {
  const location = useLocation();
  return createElement(Navigate, {
    to: conquestsRedirectTarget(
      location.pathname,
      location.search,
      location.hash,
    ),
    replace: true,
  });
}

export function conquestsRedirectTarget(
  pathname: string,
  search: string,
  hash = "",
): string {
  const query = new URLSearchParams(search);
  const target = withConquestsAreaSearchParams(
    query,
    areaFromDestination(`${pathname}${search}`),
  );
  // #242 C1b: preserva a âncora (ex.: #conquests-profile-history) na entrada
  // direta por URL legada — o perfil da Central foca a seção ao montar.
  //
  // 05/08 (#245): o destino passa a ser a ROTA. Antes apontava para `/` porque
  // `ConquestsPage` montava `MobileAppFrame` incondicionalmente e o desktop
  // ganharia moldura de telefone. A rota agora escolhe a superfície
  // (ConquestsRoutePage), então o desktop rebate sozinho para o overlay e o
  // link legado deixa de precisar adivinhar o tamanho da tela.
  return `${CONQUESTS_ROUTE_PATH}?${target.toString()}${hash}`;
}

const routes: RouteObject[] = [
  { path: "/gamification-showcase", Component: GamificationShowcasePage },
  {
    // 07/08: o portão fica FORA do `RequireAuth`. Com o flag mestre desligado a
    // rota não existe para ninguém, e um 404 não pode exigir login — hoje, em
    // produção, `/conquistas` cai no catch-all sem passar por autenticação.
    Component: ConquestsMasterRouteGate,
    children: [
      {
        Component: RequireAuth,
        children: [
          { path: CONQUESTS_ROUTE_PATH, Component: ConquestsRoutePage },
          { path: "/gamification", Component: LegacyConquestsRedirect },
          { path: "/ranking", Component: LegacyConquestsRedirect },
          { path: "/gamification/history", Component: LegacyConquestsRedirect },
        ],
      },
    ],
  },
];

export default routes;
